import { createTheme } from '@material-ui/core/styles'
import { colors } from 'utils/colors'

export const darkTheme = createTheme({
  palette: {
    type: 'dark',
    primary: {
      main: colors.blue
    },
    secondary: {
      main: colors.green
    },
    background: {
      paper: '#31324E',
      default: '#000229'
    }
  },
  typography: {
    fontSize: 13,
    fontFamily: 'Raleway'
  },
  shape: {
    borderRadius: '0.5rem'
  }
})

export const lightTheme = createTheme({
  palette: {
    type: 'light',
    background: {
      default: '#fff'
    },
    primary: {
      main: colors.indigo,
      contrastText: '#fff'
    },
    secondary: {
      main: colors.indigo
    }
  },
  typography: {
    fontSize: 13,
    fontFamily: 'Raleway'
  },
  shape: {
    borderRadius: '0.5rem'
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 400,
      md: 700,
      lg: 1100,
      xl: 1400
    }
  }
})
